var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyst6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 384,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 168,
    width: 387,
    height: 384
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 296,
    width: 138,
    height: 138
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-446 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M832.781 315.7C832.781 421.7 735.548 551.863 622.279 551.863 509.01 551.863 446 473.106 446 367.106 446 261.106 509.018 168 622.279 168 735.54 168 832.781 209.7 832.781 315.7",
    fill: "#EBF2FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.28 302.621 682.657 302.621 682.657 427.998 557.28 427.998Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.728 315.681 672.209 315.681 672.209 347.025 567.728 347.025Z",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinejoin: "round",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.728 409.792 599.531 377.662 616.716 394.12 637.726 373.145 649.429 384.555",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.209 344.862 672.209 412.775",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinecap: "round",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.728 344.862 567.728 381.43",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinecap: "round",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.277 414.938 672.209 414.938",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinecap: "round",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.684 331.353 656.537 331.353",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinecap: "round",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.4 331.344 586.012 331.344",
    stroke: "#103CA3",
    strokeWidth: 8.55,
    strokeLinecap: "round",
    fill: "none",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyst6);
export default __webpack_public_path__ + "static/media/analyst6.87823680fa258bd24bfefe23bf5780a0.svg";
export { ForwardRef as ReactComponent };